export const RETURN_HOME_EVENT = 'ebaydle:return-home';
export const START_CATEGORY_EVENT = 'ebaydle:start-category';

export interface StartCategoryEventDetail {
    category: string;
}
